<template>
  <v-card>
    <v-card-title>
      {{ $t('REPORTS.COMMUNICATION_OPTIONS') }}
    </v-card-title>

    <v-container grid-list-md text-md-right fluid fill-height>
      <v-spacer></v-spacer>
      <v-btn @click="getFile">
        {{ $t('BUTTON.EXPORT') }}
      </v-btn>
    </v-container>
  </v-card>
</template>

<script>
import { ReportsService } from '@/services/reports.service';
import downloadFile from '@/modules/_global/mixins/download-file';

export default {
  name: 'CustomersCommunicationOptions',

  components: {},
  mixins: [downloadFile],

  data: () => ({}),

  methods: {
    getFile() {
      ReportsService.getCommunicationoptionsReport()
        .then(response => {
          const filename = this.$t('REPORTS.COMMUNICATION_OPTIONS');

          this.downloadFile(response, `${filename}.xlsx`);
        })
        .catch(error => {
          this.$emit('error', error);
        });
    }
  }
};
</script>
